module.exports = __webpack_public_path__ + "d646c061e6a1d735fb4ad524d6dc16b7.svg";